import React, { createContext, useState, useContext, useEffect } from 'react';
import { getUserInfo } from '../services/userService';

const UserContext = createContext();

export const UserProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchUserInfo = async () => {
            // Only fetch user info if we have an access token
            const token = localStorage.getItem('accessToken');
            if (!token) {
                setUser(null);
                setLoading(false);
                return;
            }

            setLoading(true);
            try {
                const userInfo = await getUserInfo();
                setUser(userInfo);
                setError(null);
            } catch (err) {
                setError('Failed to fetch user information');
                console.error('Error fetching user info:', err);
                setUser(null);
            } finally {
                setLoading(false);
            }
        };

        // Watch for token changes
        const handleStorageChange = (e) => {
            if (e.key === 'accessToken') {
                fetchUserInfo();
            }
        };

        window.addEventListener('storage', handleStorageChange);
        fetchUserInfo();

        return () => {
            window.removeEventListener('storage', handleStorageChange);
        };
    }, []);

    return (
        <UserContext.Provider value={{ user, loading, error, setUser }}>
            {children}
        </UserContext.Provider>
    );
};

export const useUser = () => {
    const context = useContext(UserContext);
    if (!context) {
        throw new Error('useUser must be used within a UserProvider');
    }
    return context;
};
